"use client";

import { motion } from "src/lib/motion";
import { cn } from "@/lib/utils";
import BlurFade from "@/components/magicui/blur-fade";
import { Users, Briefcase, UsersRound } from "lucide-react";
import { useTranslations } from "@/lib/hooks/use-translations";
import { ReactNode } from "react";

interface StatItem {
  value: string;
  label: string;
  icon: ReactNode;
}

export default function StatisticsSection() {
  const { t } = useTranslations();
  
  const STAT_ICONS = [
    <Users key="users" className="h-8 w-8" />,
    <Briefcase key="briefcase" className="h-8 w-8" />,
    <UsersRound key="users-round" className="h-8 w-8" />
  ];

  const stats = t<Array<{ value: string; label: string }>>('pages.about.statistics.items').map((stat, index: number) => ({
    ...stat,
    icon: STAT_ICONS[index]
  }));

  return (
    <section className=" py-4 pb-0"> {/* Reduced bottom padding from py-16 to pb-12 */}
      <div className="container mx-auto px-6 pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto"> {/* Changed grid-cols-2 to grid-cols-1 for small screens, md:grid-cols-4 to sm:grid-cols-3 */}
          {stats.map((stat, index) => (
            <BlurFade key={index} delay={0.1 * index} inView className="text-center"> {/* Added text-center directly */}
              {/* Removed Card and CardContent wrappers */}
              <div className="flex flex-row md:flex-col max-md:gap-8 items-center justify-start md:justify-center p-6 h-full"> {/* Kept flex container for centering */}
                <div className="mb-4 text-primary [&>svg]:max-md:h-12 [&>svg]:max-md:w-12">{stat.icon}</div>
                <div className="flex flex-col items-start md:items-center justify-start md:justify-center">
                  <div className="text-4xl md:text-5xl font-bold break-words text-foreground mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm max-md:text-left text-muted-foreground">
                    {stat.label}
                  </div>
                </div>
                
              </div>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
}
